import { SessionState, AudioState } from "../../types";

// Debounce settings
export const TRANSCRIPTION_DEBOUNCE_MS = 500; // Reduced from 2000ms for faster responses

// Initial state objects
export const INITIAL_SESSION_STATE: SessionState = {
  isConnected: false,
  isConnecting: false,
  isDisconnecting: false,
  sessionId: null,
  isUsingFallback: false,
  avatarReady: false,
  isPaused: false,
};

export const INITIAL_AUDIO_STATE: AudioState = {
  isRecording: false,
  isSpeaking: false,
  audioLevel: 0,
};

// Window event names
export const WINDOW_EVENTS = {
  CONNECTION_FATAL_ERROR: "connection_fatal_error",
  AVATAR_READY: "avatar_ready",
  AVATAR_CHAT_MESSAGE: "avatar_chat_message",
  USER_CHAT_MESSAGE: "user_chat_message",
  VOICE_TRANSCRIPTION: "voice_transcription",
  MICROPHONE_ERROR: "microphone_error",
  RECORDING_ERROR: "recording_error",
  RECORDING_STATUS_CHANGED: "recording_status_changed",
  AVATAR_ERROR: "avatar_error",
  AVATAR_FATAL_ERROR: "avatar_fatal_error",
  SOCKET_CONNECTED: "socket_connected",
  INTERRUPT_AVATAR: "interrupt_avatar",
} as const;

// Socket event names
export const SOCKET_EVENTS = {
  // Session lifecycle
  SESSION_STARTED: "session_started",
  SESSION_PAUSED: "session_paused",
  SESSION_RESUMED: "session_resumed",
  INTERVIEW_COMPLETED: "interview_completed",
  DISCONNECTED: "disconnected",
  RECONNECTING: "reconnecting",
  RECONNECTED: "reconnected",
  MAX_RECONNECT_ATTEMPTS_REACHED: "max_reconnect_attempts_reached",

  // Errors
  SESSION_ERROR: "session_error",
  CONNECTION_ERROR: "error",

  // Avatar
  AVATAR_READY: "avatar_ready",
  AVATAR_SPEAKING: "avatar_speaking",
  AVATAR_SPEAK: "avatar_speak",
  AVATAR_INTERRUPTED: "avatar_interrupted",

  // Messaging
  USER_MESSAGE_TEXT: "user_message_text",
  MESSAGE_RECEIVED: "message_received",
  RESPONSE_TEXT: "response_text",
  SYSTEM_MESSAGE: "system_message",

  // Transcription
  TRANSCRIPTION: "transcription",
  TRANSCRIPTION_INTERIM: "transcription_interim",
  TRANSCRIPTION_FINAL: "transcription_final",

  // Streaming / audio
  STREAMING_STARTED: "streaming_started",
  STREAMING_STOPPED: "streaming_stopped",
  AUDIO_CHUNK: "audio_chunk",
  AUDIO_RECEIVED: "audio_received",
  PROCESSING_STOPPED: "processing_stopped",

  // Tool calls
  TOOL_CALL_START: "tool_call_start",
  TOOL_CALL_COMPLETE: "tool_call_complete",
  TOOL_CALL_ERROR: "tool_call_error",
} as const;

// Voice command constants
export const VOICE_COMMANDS = {
  STOP: "stop",
  STOP_WITH_PERIOD: "stop.",
} as const;

export const SIGNALR_HUB_METHODS = {
  START_SESSION: "StartInterview",
  SEND_TEXT_INPUT: "SendTextInput",
  STOP_PROCESSING: "StopProcessing",
  START_STREAMING_RECOGNITION: "StartStreamingRecognition",
  SEND_AUDIO_CHUNK: "SendAudioChunk",
  STOP_STREAMING_RECOGNITION: "StopStreamingRecognition",
  EXIT_INTERVIEW: "ExitInterview",
} as const;

// SignalR reconnect/backoff settings
export const SIGNALR_RECONNECT_BASE_DELAY_MS = 1000; // 1s initial delay
export const SIGNALR_RECONNECT_MAX_DELAY_MS = 30000; // 30s cap
export const SIGNALR_RECONNECT_BACKOFF_FACTOR = 2; // exponential factor
